document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".sms-signup__section-wrapper");
  if (!container) return;

  const form = container.querySelector("#smsSignUpForm");
  if (!form) return;

  // const firstNameInput = form.querySelector("#smsSignUpFirstName");
  const phoneInput = form.querySelector("#smsSignUpPhone");
  const emailInput = form.querySelector("#smsSignUpEmail");
  const closeBtns = container.querySelectorAll(".sms-signup__close-btn");
  const windowHeight = window.innerHeight;
  let hasTriggered = false;

  const SCRIPT_URL =
    "https://script.google.com/macros/s/AKfycbxtcF1rI-RAtIIdsvVuHqHGvTH95Eey2IRIiAUPM4gNnKCr5ms_6YuMArDJ1PsYepShHQ/exec";

  const LOCAL_STORAGE_KEY = "smsSignupSubmitted";
  const SESSION_STORAGE_KEY = "smsSignupClosed";

  // --- Show/hide helpers ---
  function showContainer() {
    container.classList.remove("sms-signup__section-wrapper--disabled");
    requestAnimationFrame(() => {
      phoneInput.focus();
    });
  }

  function hideContainer() {
    container.classList.add("sms-signup__section-wrapper--disabled");
  }

  // --- Show popup after 10s ---
  // setTimeout(() => {
  //   if (
  //     !localStorage.getItem(LOCAL_STORAGE_KEY) &&
  //     !sessionStorage.getItem(SESSION_STORAGE_KEY)
  //   ) {
  //     showContainer();
  //   }
  // }, 500);

  // -- Show popup on scroll
  function handleScroll() {
    if (hasTriggered) return;

    const scrolled = window.scrollY;

    if (
      scrolled >= windowHeight &&
      !localStorage.getItem(LOCAL_STORAGE_KEY) &&
      !sessionStorage.getItem(SESSION_STORAGE_KEY)
    ) {
      hasTriggered = true;
      showContainer();

      // Optional: remove listener after triggering
      window.removeEventListener('scroll', handleScroll);
    }
  }

  window.addEventListener('scroll', handleScroll);

  // --- Restrict phone input to numbers only ---
  phoneInput.addEventListener("input", () => {
    phoneInput.value = phoneInput.value.replace(/[^0-9]/g, "");
  });

  // --- Close button ---
  closeBtns.forEach(closeBtn => {
    closeBtn?.addEventListener("click", () => {
      hideContainer();
      sessionStorage.setItem(SESSION_STORAGE_KEY, "true");
      container.querySelector('.sms-signup__success-wrapper')?.classList.remove('sms-signup__success-wrapper--active');
      container.querySelector('.sms-signup__initial-wrapper')?.classList.remove('sms-signup__initial-wrapper--disable');
    });
  });
  // --- Form submit ---
  form.addEventListener("submit", async (e) => {
    e.preventDefault();

    const phone = phoneInput.value.trim();
    const email = emailInput.value.trim();
    const firstName = email;

    // if (!firstName) {
    //   alert("Please enter your first name");
    //   return;
    // }

    if (!email) {
      alert("Please enter your email address");
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      alert("Please enter a valid email address");
      return;
    }

    if (!phone) {
      alert("Please enter your mobile number");
      return;
    }

    // Indian phone validation
    const indianPhoneRegex = /^[6-9]\d{9}$/;
    if (!indianPhoneRegex.test(phone)) {
      alert("Please enter a valid 10-digit Indian mobile number");
      return;
    }

    const button = form.querySelector("button");
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = "Submitting...";

    try {
      const smsConsent = true; // from checkbox if implemented
      const payload = new URLSearchParams();
      payload.append("firstName", firstName);
      payload.append("email", email);
      payload.append("phone", phone);
      payload.append("tags", "pn-collection,prospect");
      payload.append("smsConsent", smsConsent);

      const res = await fetch(SCRIPT_URL, {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: payload.toString(),
      });

      const data = await res.json();

      if (data.status === "success") {
        form.reset();
        container.querySelector('.sms-signup__initial-wrapper')?.classList.add('sms-signup__initial-wrapper--disable');
        container.querySelector('.sms-signup__success-wrapper')?.classList.add('sms-signup__success-wrapper--active');
        // Mark submitted in localStorage
        localStorage.setItem(LOCAL_STORAGE_KEY, "true");
        // Clear session flag in case it was closed before
        sessionStorage.removeItem(SESSION_STORAGE_KEY);
      } else {
        alert("Error: " + (data.message || "Something went wrong"));
      }
    } catch (err) {
      console.error(err);
      alert("Network error. Please try again.");
    } finally {
      button.disabled = false;
      button.textContent = originalText;
    }
  });

  const copyButton = container.querySelector(".sms-signup__copy");
  if (copyButton) {
    copyButton.addEventListener("click", function () {
      const text = this.textContent.trim();
      const copiedText = this.querySelector('.sms-signup__copied-text');
      if (text && copiedText) {
        navigator.clipboard.writeText(text)
          .then(() => {
            copiedText.textContent = "COPIED";
            copiedText.classList.add('sms-signup__copied-text--active');
            setTimeout(() => {
              copiedText.textContent = "";
              copiedText.classList.remove('sms-signup__copied-text--active');
            }, 1000);
          })
          .catch(err => console.error("Failed to copy text:", err));
      }
    });
  }
});
